module.exports = __webpack_public_path__ + "img/done.218c4e88.svg";